import Basic from './basic.vue';
import FloatingMobile from '@/rebuild/materials/shared/floating/BaseFloatingMobile.vue';

export const componentMap = {
	basic: Basic,
	'basic-mobile': FloatingMobile
};
